import { isPositiveNumber } from "et3-type-guards";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import ClientPersonalInfo from "../../../../khattabat-clients/ClientPersonalInfo";
import ClientUserName from "../../../../khattabat-clients/ClientUserName";
import CloseOpenConversation from "./CloseOpenConversation";
import SelectMatchConversation from "./SelectConversation";
import getKhattabat101MatchStore from "../../../../../../stores/khattabat-stores/101m-stores";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const Header = withLiteObserverAndTheme<{
  matchID: number;
}>((props) => {
  const { theme, matchID } = props;
  const { colors } = theme;
  const {
    matchNationality,
    matchResidence,
    matchAge,
    matchHeight,
    matchWeight,
    matchLastLogin,
    marriageType,
    conversationID,
    matchUserName,
    isSilentBanned
  } = getKhattabat101MatchStore(matchID);
  const unreadMessagesCounter = getKhattabatSharedMessagingStore(
    conversationID.get()
  ).unreadMessagesCounter.get();
  const haveUnreadMessages = isPositiveNumber(unreadMessagesCounter);
  return (
    <ET3Div
      width={1510}
      height={80}
      alignItems={"center"}
      fDirection={"row"}
      style={{ border: `1px solid ${colors.all.gray}` }}
      color={colors.all.whiteBlue}
      justifyContent={"space-between"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <SelectMatchConversation matchID={matchID} />
      <ClientUserName
        userID={matchID}
        userName={matchUserName.get()}
        isSilentBanned={isSilentBanned.get()}
      />
      <ET3Div
        width={900}
        height={80}
        alignItems={"center"}
        fDirection={"row"}
        style={{}}
        color={""}
        justifyContent={"space-between"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        <ClientPersonalInfo
          information={matchResidence.get()}
          title={"Location"}
        />
        <ClientPersonalInfo
          information={matchNationality.get()}
          title={"Nationality"}
        />
        <ClientPersonalInfo information={`${matchAge.get()}`} title={"Age"} />
        <ClientPersonalInfo
          information={`${matchHeight.get()}`}
          title={"Height"}
        />
        <ClientPersonalInfo
          information={`${matchWeight.get()}`}
          title={"Weight"}
        />
        <ClientPersonalInfo
          information={matchLastLogin.get()}
          title={"Last Login"}
        />
        <ClientPersonalInfo information={marriageType.get()} title={""} />
      </ET3Div>
      {!haveUnreadMessages ? null : (
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={30}
          text={`${unreadMessagesCounter}`}
          isSpan={false}
          color={colors.all.red}
          style={{
            border: `1px solid ${colors.all.red}`,
            padding: 5
          }}
        />
      )}
      <CloseOpenConversation matchID={matchID} />
      <Et3Margin top={0} bottom={0} left={5} right={0} />
    </ET3Div>
  );
});

export default Header;
